<template>
  <div class="calendar__header calendar-header">
    <div class="calendar-header__row">
      <div
        class="calendar-header__arrow calendar-header__arrow_prev"
        @click="$emit('goPrevYear')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.49691e-07 8L7 16L9.5 16L3.5 9L16 9L16 7L3.5 7L9.5 -2.84124e-07L7 -3.93402e-07L3.49691e-07 8Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <div class="calendar-header__date">
        <div class="calendar-header__year">{{ year }}</div>
      </div>
      <div
        class="calendar-header__arrow calendar-header__arrow_next"
        @click="$emit('goNextYear')"
      >
        <svg
          v-if="yearsDiff > 18"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
    <div class="calendar-header__row">
      <div
        class="calendar-header__arrow calendar-header__arrow_prev"
        @click="$emit('goPrev')"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.49691e-07 8L7 16L9.5 16L3.5 9L16 9L16 7L3.5 7L9.5 -2.84124e-07L7 -3.93402e-07L3.49691e-07 8Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <div class="calendar-header__date">
        <div class="calendar-header__month">{{ formattedMonth }}</div>
      </div>
      <div
        class="calendar-header__arrow calendar-header__arrow_next"
        @click="$emit('goNext')"
      >
        <svg
          v-if="yearsDiff > 18"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 8L9 16L6.5 16L12.5 9L-3.0598e-07 9L-3.93402e-07 7L12.5 7L6.5 -2.84124e-07L9 -3.93402e-07L16 8Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
    <div class="calendar-header__close" @click="$emit('closeCalendar')">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 1L1 13M1 1L13 13"
          stroke="#54585A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalendarHeader",
  props: {
    month: Number,
    year: Number,
    date: Date,
  },
  data: () => ({}),
  computed: {
    months() {
      return this.$t("interface.months");
    },
    formattedMonth() {
      return this.months[this.month];
    },
    showYear() {
      return this.year === new Date().getFullYear();
    },
    yearsDiff() {
      return (
        (new Date().getTime() - this.date.getTime()) / 1000 / 60 / 60 / 24 / 365
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-header {
  padding-top: 20px;
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 17px;
  }

  &__month {
    color: #1f1f1f;
  }

  &__year {
    // margin-left: 4px;
    // font-weight: 400;
    // color: #d2d2d2;
    color: #1f1f1f;
  }

  &__date {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Noto-Sans", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
  }

  &__arrow {
    cursor: pointer;
    transition: 0.3s;
    color: #8fd24a;

    &:hover {
      color: color(green-main);
    }
  }

  &__close {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
